import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 10,
	viewBox: "0 0 7 10",
	fill: "#2E3A59",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.50025 9.99927C1.24425 9.99927 0.98825 9.90127 0.79325 9.70627C0.40225 9.31527 0.40225 8.68327 0.79325 8.29227L4.09825 4.98727L0.91825 1.69427C0.53525 1.29627 0.54625 0.663272 0.94325 0.280272C1.34125 -0.102728 1.97425 -0.0917276 2.35725 0.304272L6.21925 4.30427C6.59825 4.69727 6.59325 5.32027 6.20725 5.70627L2.20725 9.70627C2.01225 9.90127 1.75625 9.99927 1.50025 9.99927Z"
	})
});
export default SvgChevronRightreact;
